import styled from "styled-components";

export const TaxWrapper = styled.div`
  border: solid 1px #ffffff;
  background-color: #ffffff;
  margin-bottom: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 9px;
  }
`;

export const Taxes = styled(TaxWrapper)`
  padding: 20px 0 0 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 27px 0px 0px 19px;
  }
`;

export const MaskedDiv = styled.div`
  width: 9%;
  height: 88%;
  position: absolute;
  right: 0;
  z-index: 2;
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    bottom: 0;
    right: unset;
    width: 95%;
    height: 11%;
  }
`;
